import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import translate from "@insite/client-framework/Translate";
import {
    AvailabilityDto,
    AvailabilityMessageType,
    BaseModel,
    ProductSettingsModel,
    WarehouseDto,
} from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import AlertCircle from "@insite/mobius/Icons/AlertCircle";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Check from "@insite/mobius/Icons/Check";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import safeColor from "@insite/mobius/utilities/safeColor";
import CustomContactUsForm from "@tCooneyBrothers/Components/CustomContactUsForm";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

interface OwnProps {
    productId: string;
    quantity: number;
    productTitle: string;
    productNumber?: string;
    availability?: AvailabilityDto;
    unitOfMeasure: string;
    trackInventory: boolean;
    isProductDetailsPage?: boolean;
    failedToLoadInventory?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    brandName?: string;
    inventory?: any;
    isCartPage?: boolean;
    warehouseInventory?: WarehouseDto[];
}
const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    showInventory: state.context.showInventory,
    websiteSettings: getSettingsCollection(state).websiteSettings,
    settings: state.context.settings,
    state,
});
const mapDispatchToProps = {
    getRealTimeWarehouseInventory,
};
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
export interface ProductAvailabilityStyles {
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    availabilityByWarehouseLinkGridItem?: GridItemProps;
    inventoryMessage?: InjectableCss;
    messageTextBold?: TypographyPresentationProps;
    messageTextRegular?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
    availabilityByWarehouseLink?: LinkPresentationProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    availabilityByWarehouseTable?: DataTableProps;
    availabilityByWarehouseTableHead?: DataTableHeadProps;
    availabilityByWarehouseTableHeader?: DataTableHeaderProps;
    availabilityByWarehouseTableBody?: DataTableBodyProps;
    availabilityByWarehouseTableRow?: DataTableRowProps;
    availabilityByWarehouseTableCell?: DataTableCellBaseProps;
    toolTipMsg?: InjectableCss;
    toolTipText?: InjectableCss;
    messageWrapper?: InjectableCss;
    successModal?: ModalPresentationProps;
    modalContainer?: GridContainerProps;
    messageTextGridItem?: GridItemProps;
    buttonGridItem?: GridItemProps;
    continueButton?: ButtonPresentationProps;
    warehouseMessage?: InjectableCss;
    iconBox?: InjectableCss;
    iconStyle?: InjectableCss;
    availibilityGridItem?: GridItemProps;
    tooltip?: TooltipPresentationProps;
}
export const productAvailabilityStyles: ProductAvailabilityStyles = {
    container: {
        gap: 0,
        css: css`
            flex-grow: 0;
        `,
    },
    messageGridItem: { width: 12 },
    messageWrapper: {
        css: css`
            border: #ff9832 2px solid;
            background: #fbe6d0;
            padding: 3px 5px 3px 15px;
            border-radius: 5px;
            padding-left: 22px;
            font-weight: 600;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            padding: 3px 2px 3px 18px;
                            padding-left: 18px;
                        `,
                        null,
                    ],
                    "max",
                )}

            svg {
                left: -17px !important;
                width: 17px !important;
                fill: currentcolor;
                padding-top: 2px;
            }
        `,
    },
    availabilityByWarehouseLinkGridItem: { width: 12 },
    availabilityByWarehouseModal: {
        size: 400,
        cssOverrides: {
            modalContent: css`
                padding: 0px;
                > table {
                    > thead > tr {
                        border-bottom: none !important;
                        > th {
                            color: #f8f9fa !important;
                            background-color: #333333 !important;
                            border-bottom: none !important;
                            padding: 0 12px 0px 30px;
                            span[class^="TypographyStyle"] {
                                font-size: 18px;
                                font-weight: normal;
                                text-transform: uppercase;
                            }
                        }
                    }
                    > tbody > tr {
                        > td {
                            padding: 0 12px 0px 30px;
                        }
                    }
                }
            `,
        },
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    messageTextBold: {
        css: css`
            width: auto;
            font-weight: 600;
            align-self: baseline;
        `,
    },
    messageTextRegular: {
        css: css`
            width: auto;
            align-self: baseline;
            margin-left: 4px;
        `,
    },
    realTimeText: {
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;
            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }
            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    errorText: {
        css: css`
            width: 100%;
            word-wrap: break-word;
        `,
    },
    toolTipMsg: {
        css: css`
            color: #8f2400;
            cursor: pointer;
            padding-top: 3px;
            [class^="IconWrapper"] {
                position: absolute;
                height: 20px;
                svg {
                    position: absolute;
                    left: -14px;
                    top: calc(50% - 3px);
                    transform: translateY(-50%);
                    width: 13px;
                    color: #8f2400;
                }
            }
            > div[class^="TooltipWrapper"] {
                padding-right: 3px;
                > button {
                    padding: 0px 5px 0 1px;
                    span {
                        color: #fff;
                        height: 20px;
                        padding: 0px 5px 0px 1px;
                        position: absolute;
                        width: 180px;
                        left: -13px;
                        top: -15px;
                        svg {
                            fill: #ff9832 !important;
                        }
                    }
                }
            }
        `,
    },
    toolTipText: {
        css: css`
            padding-left: 6px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 11px;
                        `,
                        css`
                            font-size: 11px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    successModal: {
        sizeVariant: "small",
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
                border-bottom: 3px solid #ef3742;
                background: #fafafa;
            `,
            modalContent: css`
                padding: 30px;
                padding-top: 0;
            `,
            modalBody: css`
                max-height: calc(100% - 40px) !important;
            `,
        },
    },
    messageTextGridItem: {
        width: 12,
        css: css`
            padding-top: 25px;
            padding-bottom: 0;
        `,
    },
    buttonGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    warehouseMessage: {
        css: css`
            font-size: 12px;
            font-style: italic;
            width: 100%;
            text-wrap: wrap;
        `,
    },
    iconBox: {
        css: css`
            width: 17px;
            height: 16px;
            margin-right: 9px;
            border: 1px solid #58b46c;
        `,
    },
    iconStyle: {
        css: css`
            svg {
                margin-bottom: 12px !important;
            }
        `,
    },
    availibilityGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            padding: 0px;

            max-width: fit-content !important;
        `,
    },
    availabilityByWarehouseLink: {
        css: css`
            padding-left: 10px;
        `,
    },
    availabilityByWarehouseTableRow: {
        css: css`
            &:nth-child(even) {
                background: none;
            }
        `,
    },
    tooltip: {
        iconProps: {
            size: 13,
        },
        cssOverrides: {
            tooltipWrapper: css`
                margin-left: 4px;
            `,
            tooltipBody: css`
                white-space: pre-line;
                border: 2px solid #ffffff;
                box-shadow: rgba(0, 0, 0, 0.3) 1px 2px 8px;
            `,
        },
    },
};
const InventoryMessage = styled.div<{ color: string }>`
    display: flex;
    align-items: center;
    padding: 5px 10px 5px 5px;
    border-radius: 5px;
    background-color: #d2ebd7;
    border: 2px solid #58b46c;
    ${IconWrapper} {
        margin-right: 10px;
        color: #58b46c;
    }
`;
// /* background-color: ; */
const getAvailabilityColor = (availability?: AvailabilityDto) => {
    let color = "success";
    if (!availability) {
        return color;
    }
    const availabilityType = availability.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        color = "danger";
    } else if (availabilityType === AvailabilityMessageType.LowStock) {
        color = "warning";
    }
    return color;
};
const getAvailabilityIcon = (availability?: AvailabilityDto) => {
    let iconSrc = Check;
    if (!availability) {
        return iconSrc;
    }
    const availabilityType = availability.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        iconSrc = X;
    } else if (availabilityType === AvailabilityMessageType.LowStock) {
        iconSrc = AlertTriangle;
    }
    return iconSrc;
};
const showLink = (
    availability: AvailabilityDto | undefined,
    trackInventory: boolean,
    productSettings: ProductSettingsModel,
    isProductDetailsPage?: boolean,
): boolean => {
    if (
        !availability ||
        availability.messageType === AvailabilityMessageType.NoMessage ||
        // !trackInventory ||
        !productSettings.showInventoryAvailability ||
        !productSettings.displayInventoryPerWarehouse
    ) {
        return false;
    }
    if (!productSettings.displayInventoryPerWarehouseOnlyOnProductDetail) {
        return true;
    }
    return !!isProductDetailsPage;
};

const getStockInfo = (qty: number, rangeStr?: string, thresholdStr?: string) => {
    if (!rangeStr || !thresholdStr) {
        return { display: qty.toString(), minValue: qty, isRange: false };
    }

    // 1. Check Exact Range
    const [exactMin, exactMax] = rangeStr.split("-").map(Number);
    if (qty >= exactMin && qty <= exactMax) {
        return { display: qty.toString(), minValue: qty, isRange: false };
    }

    // 2. Check Thresholds
    const ranges = thresholdStr.split("|").map(s => s.trim());
    for (const range of ranges) {
        const [minStr, maxStr] = range.split("-");
        const min = parseInt(minStr, 10);
        const max =
            // eslint-disable-next-line no-restricted-globals
            maxStr?.toLowerCase() === "max" || isNaN(parseInt(maxStr, 10)) ? Infinity : parseInt(maxStr, 10);

        if (qty >= min && qty <= max) {
            return { display: `${min}+`, minValue: min, isRange: true };
        }
    }

    return { display: qty.toString(), minValue: qty, isRange: false };
};

const getAggregatedQty = (warehouses?: WarehouseWithBase[]) => {
    if (!warehouses?.length) return null;

    let totalMin = 0;
    let hasThirdParty = false;
    let hasAnyRange = false;

    warehouses.forEach(warehouse => {
        const isThirdParty = !!warehouse.properties?.vendorInventoryTime;
        if (isThirdParty) {
            hasThirdParty = true;
            const info = getStockInfo(
                warehouse.qty,
                warehouse.properties?.stockDisplayRange,
                warehouse.properties?.maximumStockDisplayThreshold,
            );
            totalMin += info.minValue;
            if (info.isRange) hasAnyRange = true;
        } else {
            totalMin += warehouse.qty;
        }
    });

    if (!hasThirdParty) return null;
    return hasAnyRange ? `${totalMin}+` : `${totalMin}`;
};

type WarehouseWithBase = WarehouseDto & Partial<BaseModel>;

const ProductAvailability: FC<Props> = ({
    productId,
    quantity,
    productTitle,
    productNumber,
    availability,
    unitOfMeasure,
    trackInventory,
    productSettings,
    isProductDetailsPage,
    getRealTimeWarehouseInventory,
    failedToLoadInventory,
    showInventory,
    extendedStyles,
    brandName,
    inventory,
    settings,
    isCartPage,
    state,
    warehouseInventory,
}) => {
    const donotDisplayPrice =
        state?.data?.products?.byId[productId]?.properties?.donotDisplayPrice?.toLowerCase() === "true" || false;
    const discontinuedProduct =
        state?.data?.products?.byId[productId]?.properties?.discontinuedProduct?.toLowerCase() === "true" || false;
    if (donotDisplayPrice || discontinuedProduct) {
        return null;
    }
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [warehouses, setWarehouses] = React.useState<WarehouseWithBase[] | undefined>(undefined);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);
    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const viewAvailabilityByWarehouseClickHandler = () => {
        // Track see_locations_click event
        const dataLayer = (window as any).dataLayer || [];
        if (dataLayer) {
            // Reset previous ecommerce object
            dataLayer.push({ ecommerce: null });

            // Push the in_stock_item_click event with product info
            dataLayer.push({
                event: "in_stock_item_click",
                ecommerce: {
                    items: [
                        {
                            item_id: productId,
                            item_number: productNumber,
                            item_name: productTitle,
                            item_brand: brandName,
                            item_quantity: quantity,
                            item_UOM: unitOfMeasure,
                        },
                    ],
                },
            });
        }

        setIsLoading(true);
        setModalIsOpen(true);
        getRealTimeWarehouseInventory({
            productId,
            unitOfMeasure,
            expand: ["warehouses"],
            onComplete: result => {
                setWarehouses(result.warehouses);
                setErrorMessage(result.errorMessage);
                setIsLoading(false);
            },
        });
    };

    const color = getAvailabilityColor(availability);
    const iconSrc = getAvailabilityIcon(availability);

    const [styles] = React.useState(() => mergeToNew(productAvailabilityStyles, extendedStyles));
    if (!showInventory) {
        return null;
    }
    const continueButtonClickHandler = () => {
        setIsModalOpen(false);
        clearForm();
    };

    const continueButtonClickHandlerToParent = (modalState: boolean) => {
        modalState = false;
        setIsModalOpen(modalState);
        clearForm();
    };

    const onButtonClickHandler = () => {
        // Track check_availability_click event
        const dataLayer = (window as any).dataLayer || [];
        if (dataLayer) {
            // Reset previous ecommerce object
            dataLayer.push({ ecommerce: null });
            // Push the check_availability_click event with product info
            dataLayer.push({
                event: "check_availability_click",
                ecommerce: {
                    items: [
                        {
                            item_id: productId,
                            item_number: productNumber,
                            item_name: productTitle,
                            item_brand: brandName,
                            item_qunatity: quantity,
                            item_UOM: unitOfMeasure,
                        },
                    ],
                },
            });
        }
        setIsModalOpen(true);
    };

    // Replace the existing [warehouses] state with this:
    const preparedWarehouses = React.useMemo(() => {
        if (!warehouses) return [];

        return warehouses
            .filter(w => w.name === settings?.properties?.cooneyWarehouseName || w.qty > 0)
            .map(w => {
                const info = getStockInfo(
                    w.qty,
                    w.properties?.stockDisplayRange,
                    w.properties?.maximumStockDisplayThreshold,
                );
                return {
                    ...w,
                    calculatedDisplayQty: w.properties?.vendorInventoryTime ? info.display : w.qty.toString(),
                };
            });
    }, [warehouses, settings]);

    const contactUsModalCloseHandler = () => setIsModalOpen(false);
    if (failedToLoadInventory) {
        return (
            <StyledWrapper {...styles.errorWrapper}>
                <Typography {...styles.errorText} data-test-selector="inventoryLoadFailedMessage">
                    {siteMessage("RealTimeInventory_InventoryLoadFailed")}
                </Typography>
            </StyledWrapper>
        );
    }

    let inventoryTextComponent = <Typography {...styles.realTimeText} />;
    // let qty = 0;
    // if(inventory?.inventoryWarehousesDtos.length > 0) {
    //     inventory?.inventoryWarehousesDtos[0].warehouseDtos.forEach((dto: any) => {
    //         qty += dto.qty;
    //     });
    // }
    // let checkAvailibity = (qty === 0);
    // if(!inventory) {
    //     checkAvailibity = availability?.messageType === AvailabilityMessageType.OutOfStock;
    // }
    if (availability && availability.messageType !== AvailabilityMessageType.NoMessage) {
        if (availability.messageType === AvailabilityMessageType.OutOfStock) {
            const { message } = availability;
            inventoryTextComponent = (
                <StyledWrapper {...styles.messageWrapper}>
                    <StyledWrapper {...styles.toolTipMsg} onClick={onButtonClickHandler}>
                        <Icon color={color} src={AlertCircle} />
                        <Typography {...styles.toolTipText} data-test-selector="callForAvailability">
                            {translate("Check Availability")}
                        </Typography>
                    </StyledWrapper>
                    <Modal
                        headline={translate("Availability Information")}
                        contentLabel="Availability Information"
                        {...styles.successModal}
                        isOpen={isModalOpen}
                        handleClose={contactUsModalCloseHandler}
                    >
                        <GridContainer {...styles.modalContainer}>
                            <GridItem {...styles.messageTextGridItem}>
                                <CustomContactUsForm
                                    availability={availability}
                                    parentModalState={continueButtonClickHandlerToParent}
                                    productQty={quantity}
                                    productTitle={productTitle}
                                    productNumber={productNumber}
                                    brandName={brandName}
                                />
                            </GridItem>
                        </GridContainer>
                    </Modal>
                </StyledWrapper>
            );
        } else {
            const position = availability.message.indexOf(" at ");
            let regularPart = "";
            if (position !== -1) {
                regularPart = availability.message.substring(position);
            }
            const aggregatedQty = getAggregatedQty(warehouseInventory);

            let displayMessage = availability.message;

            if (aggregatedQty) {
                displayMessage = `In Stock: ${aggregatedQty}`;
            }
            inventoryTextComponent = (
                <InventoryMessage color={color} {...styles.inventoryMessage}>
                    <GridContainer gap={0}>
                        <GridItem {...styles.availibilityGridItem}>
                            <StyledWrapper {...styles.iconBox}>
                                <Icon color={color} src={iconSrc} {...styles.iconStyle} />
                            </StyledWrapper>
                            <Typography {...styles.messageTextBold} data-test-selector="availabilityMessage">
                                {displayMessage}
                            </Typography>
                            {regularPart && (
                                <Typography {...styles.messageTextRegular} data-test-selector="availabilityMessage">
                                    {regularPart}
                                </Typography>
                            )}
                        </GridItem>
                        {(isCartPage || inventory) && (
                            <GridItem {...styles.availibilityGridItem}>
                                {showLink(availability, trackInventory, productSettings, isProductDetailsPage) && (
                                    <GridItem {...styles.availabilityByWarehouseLinkGridItem}>
                                        <Link
                                            {...styles.availabilityByWarehouseLink}
                                            onClick={viewAvailabilityByWarehouseClickHandler}
                                            data-test-selector="availabilityByWarehouseLink"
                                        >
                                            {isCartPage === true
                                                ? translate("See Lead Time Details")
                                                : translate("See Locations")}
                                        </Link>
                                        <Modal
                                            {...styles.availabilityByWarehouseModal}
                                            headline={translate("Inventory by Location")}
                                            isOpen={modalIsOpen}
                                            handleClose={modalCloseHandler}
                                        >
                                            {isLoading && (
                                                <StyledWrapper {...styles.centeringWrapper}>
                                                    <LoadingSpinner {...styles.spinner} />
                                                </StyledWrapper>
                                            )}
                                            {!isLoading && (
                                                <>
                                                    {errorMessage ? (
                                                        <div>{errorMessage}</div>
                                                    ) : (
                                                        <DataTable
                                                            {...styles.availabilityByWarehouseTable}
                                                            data-test-selector="availabilityByWarehouseModal"
                                                        >
                                                            <DataTableHead {...styles.availabilityByWarehouseTableHead}>
                                                                <DataTableHeader
                                                                    {...styles.availabilityByWarehouseTableHeader}
                                                                >
                                                                    {translate("Warehouse")}
                                                                </DataTableHeader>
                                                                <DataTableHeader
                                                                    {...styles.availabilityByWarehouseTableHeader}
                                                                >
                                                                    {translate("Qty")}
                                                                </DataTableHeader>
                                                            </DataTableHead>
                                                            <DataTableBody {...styles.availabilityByWarehouseTableBody}>
                                                                {preparedWarehouses.map(warehouse => (
                                                                    <DataTableRow
                                                                        {...styles.availabilityByWarehouseTableRow}
                                                                        key={warehouse.name}
                                                                    >
                                                                        <DataTableCell
                                                                            {...styles.availabilityByWarehouseTableCell}
                                                                            data-test-selector="warehouseAvailabilityModal_Description"
                                                                        >
                                                                            {warehouse.description || warehouse.name}
                                                                            {warehouse.properties
                                                                                ?.vendorInventoryTime && (
                                                                                <Tooltip
                                                                                    {...styles.tooltip}
                                                                                    text={`${siteMessage("ThirdParty_Invmsg").toString()} \n${warehouse.properties.vendorInventoryTime}`}
                                                                                />
                                                                            )}
                                                                            {warehouse.name ===
                                                                                settings?.properties
                                                                                    ?.cooneyWarehouseName &&
                                                                            warehouse.qty === 0 ? null : (
                                                                                <StyledWrapper
                                                                                    {...styles.warehouseMessage}
                                                                                >
                                                                                    {warehouse.message}
                                                                                </StyledWrapper>
                                                                            )}
                                                                        </DataTableCell>
                                                                        <DataTableCell
                                                                            {...styles.availabilityByWarehouseTableCell}
                                                                            data-test-selector="warehouseAvailabilityModal_Quantity"
                                                                        >
                                                                            {warehouse.calculatedDisplayQty}
                                                                        </DataTableCell>
                                                                    </DataTableRow>
                                                                ))}
                                                            </DataTableBody>
                                                        </DataTable>
                                                    )}
                                                </>
                                            )}
                                        </Modal>
                                    </GridItem>
                                )}
                            </GridItem>
                        )}
                    </GridContainer>
                </InventoryMessage>
            );
        }
    } else if (availability) {
        inventoryTextComponent = <></>;
    }

    return (
        <GridContainer {...styles.container}>
            <GridItem data-test-selector="availability_wrapper" {...styles.messageGridItem}>
                {inventoryTextComponent}
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAvailability);
